import { httpCreate } from './http';

const http = httpCreate('/srv/tencent-upload');

export const tencentUpload = {
	getToken(activityId) {
		return http.get(`/sign/${activityId}`);
	},
};
